import React from 'react'

import { colors } from 'shared/styles/colors'

import {
  Loading as LoadingStyle,
  Title,
  ContainerBackdrop,
  Container,
} from './styles'

interface ILoadingProps {
  open?: boolean
  color?: string
}

const LoadingBackdrop: React.FC<ILoadingProps> = ({ open, color }) => (
  <>
    {open && (
      <ContainerBackdrop>
        <Container>
          <LoadingStyle color={color || colors.green} />
          <Title>Aguarde...</Title>
        </Container>
      </ContainerBackdrop>
    )}
  </>
)
export default LoadingBackdrop
